import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  PanelWrapper,
  PanelHeader,
  PanelContent,
  ParsedContent,
  PanelActions
} from './HomePage.style';

const OurFoodPanel = ({
    content,
    headerColor,
    renderTradeShowButton
}) => {
  const {ourFood, ourFoodSectionTitle} = content;
  const title = ourFoodSectionTitle || <FormattedMessage id="home.ourFood.title" />;

  return (
    <PanelWrapper>
      <PanelHeader headerColor={headerColor}>{title}</PanelHeader>
      <PanelContent data-rw="home-page--our-food">
        <ParsedContent
          headerColor={headerColor}
          dangerouslySetInnerHTML={{__html: ourFood}} // eslint-disable-line react/no-danger
        />
      </PanelContent>
      <PanelActions>
        {renderTradeShowButton}
      </PanelActions>
    </PanelWrapper>
  );
};

OurFoodPanel.propTypes = {
  content: PropTypes.object.isRequired,
  headerColor: PropTypes.string.isRequired,
  renderTradeShowButton: PropTypes.func.isRequired
};
export default OurFoodPanel;



// WEBPACK FOOTER //
// ./containers/HomePage/OurFoodPanel.js